import { render } from "./address_and_hotel.vue?vue&type=template&id=5c1fddde"
import script from "./address_and_hotel.vue?vue&type=script&lang=js"
export * from "./address_and_hotel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__